import { Grid, makeStyles, Paper } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const useCardSkeletonStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
  },
  imageWrapper: {
    position: 'relative' as const,
    width: '100%',
    paddingTop: '75%', // 4:3
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    marginBottom: theme.spacing(1),
  },
  imageSkeleton: {
    position: 'absolute' as const,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
}));

export const RecommendationCardSkeleton = () => {
  const classes = useCardSkeletonStyles();
  return (
    <Paper className={classes.root} elevation={2}>
      <div className={classes.imageWrapper}>
        <Skeleton variant="rect" className={classes.imageSkeleton} />
      </div>
      <Skeleton variant="text" width="80%" height={28} />
      <Skeleton variant="text" width="40%" height={20} />
      <Skeleton variant="rect" width={100} height={22} style={{ marginTop: 4, borderRadius: 4 }} />
    </Paper>
  );
};

const useRowSkeletonStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1.5, 2),
  },
  thumbnail: {
    borderRadius: theme.shape.borderRadius,
    flexShrink: 0,
  },
}));

export const RecommendationRowSkeleton = () => {
  const classes = useRowSkeletonStyles();
  return (
    <Paper className={classes.root} elevation={1}>
      <Grid container alignItems="center" spacing={2} wrap="nowrap">
        <Grid item>
          <Skeleton variant="rect" width={96} height={68} className={classes.thumbnail} />
        </Grid>
        <Grid item xs>
          <Skeleton variant="text" width="60%" height={24} />
          <Skeleton variant="rect" width={90} height={20} style={{ marginTop: 4, borderRadius: 4 }} />
        </Grid>
        <Grid item>
          <Skeleton variant="text" width={70} height={24} />
          <Skeleton variant="text" width={100} height={20} />
        </Grid>
      </Grid>
    </Paper>
  );
};
